
export type Account = {
  company_id?: string;
  region: string;
  country: string;
  company_name: string;
  parent_company?: string;
  industry: string;
  account_manager: string;
};

export type FinancialData = {
  revenue: number[];
  profit: number[];
  eps: number[];
  cashFlow: number[];
  debt: number[];
  ebitdaMargins: number[];
  labels: string[];
};

export type KpiData = {
  executive: any[];
  financial: any[];
  initiatives: any[];
  operating: any[];
  solutions: any[];
};

export type FrameworkNode = {
  id: string;
  type: string;
  position: { x: number; y: number };
  data: {
    title?: string;
    description?: string;
    kpiType?: string;
  };
};

export type FrameworkEdge = {
  id: string;
  source: string;
  target: string;
};

export type FrameworkData = {
  nodes: FrameworkNode[];
  edges: FrameworkEdge[];
};

export type AnalysisResult = {
  summary: string;
  focusAreas: {
    title: string;
    description: string;
    rationale: string;
    kpiAlignment: string[];
  }[];
  salesActivities: {
    activity: string;
    impact: string;
    timeline: string;
  }[];
  executionApproach: {
    stakeholderStrategy: string;
    communicationPlan: string;
    valueProposition: string;
  };
  revenueOpportunities: {
    opportunity: string;
    potential: string;
    timeline: string;
  }[];
  riskMitigation: {
    risk: string;
    impact: string;
    mitigation: string;
  }[];
  kpiImpactAnalysis: {
    description: string;
    topKpis: string[];
  };
  error?: string;
  rawContent?: string;
};

export const COLORS = [
  '#8884d8', '#82ca9d', '#ffc658', '#ff8042', '#0088FE', 
  '#00C49F', '#FFBB28', '#FF8042', '#a4de6c', '#d0ed57'
];
